<template>
  <a-spin :spinning="loading">
    <div style="display: flex">
      <div
        class="calc-apply-wrapper"
        style="background: white; padding: 20px; width: -webkit-fill-available"
        :style="loading ? 'display: none;' : ''"
      >
        <a-result
          style="margin-top: 32px"
          status="403"
          title="Sorry"
          sub-title="没有可用流程, 如有疑问请联系管理员"
          v-if="!loading && (flowByCategory == null || JSON.stringify(flowByCategory) == '{}')"
        >
          <template #extra> </template>
        </a-result>

        <div v-else-if="!loading">
          <div class="" style="display: flex; border-bottom: 3px solid #f6f6f6; padding-bottom: 18px">
            <div
              style="
                font-size: 24px;
                width: 47px;
                height: 47px;
                display: flex;
                justify-content: center;
                align-items: center;
                background: var(--color-primary-6);
                border-radius: 2px;
                color: var(--color-primary-6);
                color: white;
                margin-right: 16px;
                filter: drop-shadow(0px 0px 1px var(--color-primary-4));
              "
            >
              <i class="mdi mdi-transit-connection-variant" style="letter-spacing: 0"></i>
            </div>
            <div>
              <div style="font-size: 18px; position: relative; top: -1px; letter-spacing: 5px; color: black">
                新建流程
              </div>
              <div style="display: flex; font-size: 14px; position: relative; top: -1px">
                <div
                  style="cursor: pointer"
                  @click="
                    $router.push({
                      name: 'k00-k0011-TaskManage',
                    })
                  "
                >
                  <span style="letter-spacing: 1px">待办流程：</span
                  ><span style="font-weight: 400; letter-spacing: 1px; color: var(--color-orange)">{{
                    myTasks.length
                  }}</span>
                </div>

                <a-divider type="vertical" style="margin: 0 12px; background: lightgrey; top: 4px"></a-divider>

                <div
                  style="cursor: pointer"
                  @click="
                    $router.push({
                      name: 'k00-k0011-TemporaryManage',
                    })
                  "
                >
                  <span style="letter-spacing: 1px">临时保存：</span
                  ><span style="font-weight: 400; letter-spacing: 1px; color: var(--color-green)">{{
                    temporaryTasks.length
                  }}</span>
                </div>

                <a-divider type="vertical" style="margin: 0 12px; background: lightgrey; top: 4px"></a-divider>

                <div
                  style="cursor: pointer"
                  @click="
                    $router.push({
                      name: 'k00-k0011-CcMeManage',
                    })
                  "
                >
                  <span style="letter-spacing: 1px">抄送给我的：</span
                  ><span style="font-weight: 400; letter-spacing: 1px; color: var(--color-cyan)">{{
                    ccTasks.length
                  }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="" style="margin-top: 15px; margin-bottom: -15px" v-if="relations.length > 1">
            <div style="font-size: 15px; margin-bottom: 5px; color: black">
              <JSharp style="margin-left: 1px; position: relative; top: -1px"></JSharp>
              <span>请选择流程所属信息：</span>
            </div>

            <div class="div-relation-wrapper">
              <div
                class="div-relation"
                v-for="relation in relations"
                :key="relation.id"
                :class="[
                  relation.id == selectedRelation.id ? 'selected' : '',
                  relation.positionName && relation.bizLineName ? 'shrink' : '',
                ]"
                @click="handleSelect(relation)"
              >
                <dt>
                  <a-icon type="check" style="color: var(--color-primary)" v-if="relation.id == selectedRelation.id" />
                  <a-icon type="idcard" theme="twoTone" v-else />
                </dt>
                <dd>
                  <span class="realname">
                    <span>{{ relation.realname }}</span>
                    <!--<span v-if="relation.postLevel" style="zoom: 1; font-size: 12px; color: var(--color-purple)"
                    >（{{ relation.postLevel }}）</span
                  >-->
                    <span
                      v-if="relation.userId != loginUser.id"
                      style="zoom: 1; font-size: 12px; color: var(--color-primary)"
                      >（代理）</span
                    >
                  </span>

                  <span>
                    <span
                      class="iconify"
                      data-icon="ci:dot-05-xl"
                      data-inline="false"
                      style="color: var(--color-blue)"
                    ></span>
                    <span class="departName">{{ relation.departName }}</span>
                  </span>

                  <span v-if="relation.positionName">
                    <span
                      class="iconify"
                      data-icon="ci:dot-05-xl"
                      data-inline="false"
                      style="color: var(--color-green)"
                    ></span>
                    <span class="positionName">{{ relation.positionName }}</span>
                  </span>

                  <span v-if="relation.bizLineName">
                    <span
                      class="iconify"
                      data-icon="ci:dot-05-xl"
                      data-inline="false"
                      style="color: var(--color-orange)"
                    ></span>
                    <span class="bizLineName">{{ relation.bizLineName }}</span>
                  </span>
                </dd>
              </div>
            </div>
          </div>

          <div class="" style="margin-top: 16px">
            <div style="font-size: 15px; margin-bottom: 0px; color: black">
              <JSharp style="margin-left: 1px; position: relative; top: -1px"></JSharp>
              <span>请选择流程：</span>
            </div>

            <div class="div-flow-filter">
              <div class="category" :class="selectedWfType == '-1' ? 'active' : ''" @click="changeCategory('-1')">
                <span>全部分类</span>
                <span
                  class="num"
                  style="
                    color: var(--color-green-6);
                    font-size: 13px;
                    position: relative;
                    top: 0px;
                    letter-spacing: 0px;
                  "
                  >（{{ flows.length }}）</span
                >
              </div>
              <div
                @click="changeCategory(value[0].wfType)"
                class="category"
                :class="selectedWfType == value[0].wfType ? 'active' : ''"
                v-for="value in flowByCategory"
                :key="value[0].wfType"
              >
                <span>{{ $getDict('wf_type', value[0].wfType) }}</span>
                <span
                  class="num"
                  style="
                    color: var(--color-green-6);
                    font-size: 13px;
                    position: relative;
                    top: 0px;
                    letter-spacing: 0px;
                  "
                  >（{{ value.length }}）</span
                >
              </div>
            </div>

            <div class="div-flow-wrapper" style="margin-top: 10px; margin-bottom: -12px; margin-right: -14px">
              <a-card style="border: 1px solid transparent">
                <a-card-grid
                  v-for="item in flowsFilter"
                  :key="item.deploymentId"
                  @click="handleOpen(item)"
                  style="width: min(calc(50% - 12px), 210px)"
                >
                  <div class="icon-wrapper">
                    <a-icon v-if="!item.icon" class="main-icon" type="edit" />
                    <i
                      v-else-if="item.icon.indexOf(':') >= 0"
                      class="iconify main-icon"
                      :data-icon="item.icon"
                      data-inline="false"
                    ></i>
                    <i v-else-if="item.icon.indexOf('mdi-') >= 0" :class="'main-icon mdi ' + item.icon"></i>
                    <a-icon v-else class="main-icon" :type="item.icon" />
                  </div>

                  <div>{{ item.name }}</div>

                  <div
                    class="process-num animate__animated animate__flipInX"
                    v-if="
                      XEUtils.filter(myTasks, (r) => r.modelId == item.modelId).length > 0 ||
                      XEUtils.filter(temporaryTasks, (r) => r.modelId == item.modelId).length > 0 ||
                      XEUtils.filter(ccTasks, (r) => r.modelId == item.modelId).length > 0
                    "
                  >
                    <div
                      title="点击显示详细"
                      @click.stop="handleTransfer(item, 'k00-k0011-TaskManage')"
                      style="
                        background: var(--color-orange-3);
                        color: var(--color-orange-8);
                        filter: drop-shadow(0px 0px 0px var(--color-orange-3)) contrast(1.1);
                      "
                      v-if="XEUtils.filter(myTasks, (r) => r.modelId == item.modelId).length > 0"
                    >
                      <a-icon type="arrow-right" />
                      <span>{{ XEUtils.filter(myTasks, (r) => r.modelId == item.modelId).length }}</span>
                    </div>

                    <div
                      title="点击显示详细"
                      @click.stop="handleTransfer(item, 'k00-k0011-TemporaryManage')"
                      style="
                        background: var(--color-green-3);
                        color: var(--color-green-8);
                        filter: drop-shadow(0px 0px 0px var(--color-green-3)) contrast(1.1);
                      "
                      v-if="XEUtils.filter(temporaryTasks, (r) => r.modelId == item.modelId).length > 0"
                    >
                      <a-icon type="arrow-right" />
                      <span>{{ XEUtils.filter(temporaryTasks, (r) => r.modelId == item.modelId).length }}</span>
                    </div>

                    <div
                      title="点击显示详细"
                      @click.stop="handleTransfer(item, 'k00-k0011-CcMeManage')"
                      style="
                        background: var(--color-cyan-3);
                        color: var(--color-cyan-8);
                        filter: drop-shadow(0px 0px 0px var(--color-cyan-3)) contrast(1.1);
                      "
                      v-if="XEUtils.filter(ccTasks, (r) => r.modelId == item.modelId).length > 0"
                    >
                      <a-icon type="arrow-right" />
                      <span>{{ XEUtils.filter(ccTasks, (r) => r.modelId == item.modelId).length }}</span>
                    </div>
                  </div>
                </a-card-grid>
              </a-card>
            </div>
          </div>
        </div>
      </div>

      <!--<div class="flow-wrapper">
        <div><div class="title">待办流程</div></div>
        <div><div class="title">临时保存</div></div>
        <div><div class="title">已办流程</div></div>
      </div>-->
    </div>

    <!-- 申請モーダル：申請フォームを載せる -->
    <ApplyModal ref="ApplyModal" @searchQuery="getTaskCount()"></ApplyModal>
  </a-spin>
</template>

<script>
import { getAction, postAction, putAction } from '@/api/manage'

export default {
  name: 'ApplyManage',
  components: {},
  data() {
    return {
      loading: false,
      applicantInfo: {},
      relations: [],
      myTasks: [],
      temporaryTasks: [],
      ccTasks: [],
      flows: [],
      flowsFilter: [],
      selectedRelation: {},
      selectedWfType: '-1',

      flowByCategory: {},
      loginUser: this.$getLoginUser(),

      url: {
        listByCategory: '/blaze-sys/k00/k0011/ApplyManage/listByCategory',
        getUserAgents: '/blaze-sys/k00/k0011/ApplyManage/getUserAgents',
        taskCount: '/flow/taskCount',
      },
    }
  },
  activated() {
    this.getTaskCount()
  },
  created() {},
  mounted() {
    // モバイルの場合、リサイズする
    resizeForMobile()

    this.loading = true

    getAction(this.url.getUserAgents, null).then((res) => {
      if (res.success) {
        this.relations = res.result
        this.handleSelect(XEUtils.first(XEUtils.filter(this.relations, (r) => r.mainFlag)))
      }
    })
  },
  methods: {
    load() {
      //this.loading = true

      getAction(this.url.listByCategory, {
        userId: this.selectedRelation.userId,
        departId: this.selectedRelation.departId,
      })
        .then((res) => {
          if (res.success) {
            var wfTypes = XEUtils.orderBy(this.$getDict('wf_type'), [['sortOrder', 'asc']])
            this.flowByCategory = {}
            wfTypes.forEach((wfType) => {
              var filter = XEUtils.filter(res.result, (r) => r.wfType == wfType.value)
              if (filter.length > 0) {
                this.flowByCategory[wfType.sortOrder] = filter
              }
            })

            this.flows = res.result
            this.flows.forEach((r) => {
              r.wfTypeSortOrder = XEUtils.filter(wfTypes, (w) => w.value == r.wfType)[0].sortOrder
            })
            this.flows = XEUtils.orderBy(this.flows, [
              ['wfTypeSortOrder', 'asc'],
              ['sortNo', 'asc'],
            ])
            this.changeCategory('-1')
          }
        })
        .finally(() => {
          this.getTaskCount()
          this.loading = false
        })
    },
    getTaskCount() {
      getAction(this.url.taskCount, { onlyCount: false })
        .then((res) => {
          if (res.success) {
            // 処理待ち.件数
            this.myTasks = res.result.myTasks
            // 一時保存.件数
            this.temporaryTasks = res.result.temporaryTasks
            // 抄送
            this.ccTasks = res.result.ccTasks
          }
        })
        .finally(() => {})
    },
    handleSelect(relation) {
      if (!relation) {
        this.load()
        return
      }

      if (this.selectedRelation.id == relation.id) {
        return
      }
      this.selectedRelation = relation

      this.applicantInfo.starterRelation = this.selectedRelation
      if (this.selectedRelation.userId != this.loginUser.id) {
        this.applicantInfo.agentRelation = XEUtils.first(
          XEUtils.filter(this.relations, (r) => r.mainFlag && r.userId == this.loginUser.id)
        )
      } else {
        this.applicantInfo.agentRelation = null
      }

      this.load()
    },
    handleOpen(item) {
      // 0 下記以外
      // 1 申請ポータル
      // 2 一時保存一覧
      // 3 未処理一覧
      // 4 処理済一覧・進行中案件 or 申請案件一覧・進行中案件
      // 5 処理済一覧・終了案件 or 申請案件一覧・終了案件
      // 6 処理済一覧・非活性案件
      this.$refs.ApplyModal.popupFrom = '1'

      this.$refs.ApplyModal.modelId = item.modelId
      this.$refs.ApplyModal.deploymentId = item.deploymentId
      this.$refs.ApplyModal.title = item.name
      this.$refs.ApplyModal.component = item.component
      this.$refs.ApplyModal.status = 'disp.flow.apply'
      this.$refs.ApplyModal.applicantInfo = this.applicantInfo
      this.$refs.ApplyModal.handleOpen()
    },
    handleTransfer(record, path) {
      this.$router.push({
        name: path,
        params: { name: record.modelName, modelId: record.modelId },
      })
    },
    changeCategory(selected) {
      this.selectedWfType = selected

      if (this.selectedWfType == '-1') {
        this.flowsFilter = this.flows
      } else {
        this.flowsFilter = XEUtils.filter(this.flows, (r) => r.wfType == this.selectedWfType)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.div-flow-filter {
  .category {
    display: inline-block;
    //background: #f8f8f8;
    padding: 5px 4px 5px 11px;
    font-size: 14px;
    margin-right: 6px;
    margin-top: 6px;
    border-radius: 6px;
    cursor: pointer;
    //min-width: 100px;
    text-align: center;
    transition: all 0.3s;
    color: #000;

    &.active {
      color: var(--color-primary-6);
      background: var(--color-primary-1);

      //.num {
      //  color: green !important;
      //}
    }

    &:hover {
      background: var(--color-primary-1);
    }
  }
}

.div-flow-wrapper {
  /deep/ .ant-card-body {
    display: flex;
    flex-wrap: wrap;
  }

  .ant-card-grid {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    padding: 25px 16px 25px;
    font-size: 15px;
    color: black;
    position: relative;
    margin-right: 12px;
    margin-bottom: 12px;
    box-shadow: none;
    background: #f8f8f8;
    height: 120px;
    //border-bottom: 2px solid #eee;

    &:before {
      content: '';
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      transform: scale(0);
      //transform-origin: 100% 50%;
      transition-property: transform;
      transition-duration: 0s;
      transition-timing-function: ease-out;
    }

    &:hover {
      //box-shadow: 0.3px 0.3px 0.6px rgba(0, 0, 0, 2%), 0.7px 0.7px 1.3px rgba(0, 0, 0, 3%),
      //  1.3px 1.3px 2.5px rgba(0, 0, 0, 4%), 2.2px 2.2px 4.5px rgba(0, 0, 0, 4%), 4.2px 4.2px 8.4px rgba(0, 0, 0, 5%),
      //  10px 10px 20px rgba(0, 0, 0, 7%);
      //background: white;

      &::before {
        transition-duration: 0.2s;
        transform: scale(1);
        //transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
        background: linear-gradient(90deg, var(--color-primary-1), var(--color-primary-1));
      }

      .icon-wrapper {
        color: var(--color-primary-8);
      }
    }

    .icon-wrapper {
      font-size: 28px;
      color: var(--color-primary);
      filter: drop-shadow(2px 2px 0px #ddd);
      position: relative;
      top: -3px;
      transition: all 0.3s;
      margin-bottom: 5px;
    }
  }
}

.process-num {
  position: absolute;
  right: 8px;
  top: 8px;
  //filter: drop-shadow(0px 0px 3px);
  color: #ddd;
  z-index: 1;
  display: flex;

  & > div {
    height: 18px;
    min-width: 18px;
    margin-left: 3px;
    display: -ms-inline-flexbox;
    display: -ms-flexbox;
    display: inline-flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 12px;
    letter-spacing: 0px;
    color: white;
    border-radius: 2px;
    transform: scale(0.9);
    font-weight: 700;
    transition: all 0.3s;
    padding: 0 5px;

    & > * {
      letter-spacing: 0;
      transition: all 0.3s;
    }

    .anticon-arrow-right {
      opacity: 0;
      position: absolute;
    }

    &:hover {
      span {
        opacity: 0;
      }

      .anticon-arrow-right {
        opacity: 1;
      }
    }
  }
}

//.ant-card-grid {
//  border-radius: 0;
//  border: 0;
//  box-shadow: 1px 0 0 0 #e8e8e8, 0 1px 0 0 #e8e8e8, 1px 1px 0 0 #e8e8e8, 1px 0 0 0 #e8e8e8 inset,
//    0 1px 0 0 #e8e8e8 inset;
//}

//.ant-card-grid:hover {
//  box-shadow: 1px 0 0 0 transparent, 0 1px 0 0 transparent, 1px 1px 0 0 transparent, 1px 0 0 0 transparent inset,
//    0 1px 0 0 #e8e8e8 inset, 0 2px 8px rgba(0, 0, 0, 0.15);
//}

//.flow-wrapper {
//  display: flex;
//  width: 738px;
//  margin-left: 12px;
//  flex-direction: column;

//  & > div {
//    background: white;
//    margin-bottom: 12px;
//    padding: 16px 20px 20px;
//    height: -webkit-fill-available;

//    &:last-child {
//      margin-bottom: 0px;
//    }

//    .title {
//      border-bottom: 2px solid #f8f8f8;
//      font-size: 15px;
//      padding-bottom: 3px;
//    }
//  }
//}
</style>


